/**
 * onboarding-steps.js
 *
 * Step content for the two first-run tours (Dashboard, Coin Detail).
 * See src/components/onboarding-tour.js for the generic Joyride wrapper
 * that renders these, and src/context/auth-context.js for the trigger/
 * persistence logic.
 */

import { firstMatch } from '../components/onboarding-tour';

// Dashboard's mobile and desktop views are genuinely different component
// trees (a table on desktop, cards on mobile — see market-table.js's
// isMobile branch), so several steps below use firstMatch() to try the
// desktop selector first and fall back to the mobile equivalent — only one
// of each pair ever exists in the DOM at a time.
export const DASHBOARD_TOUR_STEPS = [
  {
    target: 'body',
    placement: 'center',
    content: "Welcome to CryptoProScanner! Let's take a quick look around your dashboard.",
  },
  {
    target: '.direction-filter',
    content: 'Filter the list to coins currently trending Long, Short, or show everything.',
  },
  {
    target: '.search-bar',
    content: 'Search for any coin by name or symbol.',
  },
  {
    target: firstMatch('[data-tour="col-name"]', '.mcc-coin-name'),
    content: "Click a coin's name to view its detail page and chart.",
  },
  {
    target: firstMatch('.trend-header:not(.sma-slope-header)', '.mcc-trend-row'),
    content: "Weekly, Daily, and 4H are timeframes. When all three align, that's a strong signal.",
  },
  {
    target: firstMatch('.sma-slope-header', '.mcc-sma-row'),
    content: 'Shows whether the 50 Simple Moving Average is sloping up or down across those three timeframes.',
  },
  {
    target: firstMatch('[data-tour="col-volume"]', '.mcc-volume'),
    content: "A ⚡ lightning icon with bold volume means a volume spike — an important alert. Shaded volume means it's been high on at least 3 of the last 10 days.",
  },
  {
    target: '.watchlist-btn',
    content: 'Click the star to save a coin to your Watchlist.',
  },
  {
    target: '[data-tour="nav-watchlist"]',
    content: "Find every coin you've starred here anytime.",
  },
  {
    target: '[data-tour="nav-alerts-log"]',
    content: 'See alerts for the strategies included in your plan.',
  },
  {
    target: '[data-tour="nav-support"]',
    content: "Get support if you're stuck.",
  },
  {
    target: '[data-tour="nav-settings"]',
    content: 'Set your Telegram and email alerts for the strategies you want to be notified about.',
  },
];

export const COIN_DETAIL_TOUR_STEPS = [
  {
    target: '.volume-section',
    content: 'Volume Analysis shows the 200-day average volume alongside the last 30 days — bars in green are above average, and the Vol/Avg ratio shows exactly how much higher.',
  },
  {
    target: '.chart-section',
    content: 'A candlestick price chart, defaulting to Daily — switch to Weekly or 4H with the tabs above. Includes the 50 Simple Moving Average and volume.',
  },
  {
    target: '.coin-about-title',
    content: "The project's own description.",
  },
  {
    target: '.coin-news-title',
    content: 'Any recent news found about this coin.',
  },
];
